import { data } from "../../../shared/state/payload";

export const categoryFilters = {
	hotelTypes: data.hotelTypes,
	criteria: data.criteria,
};

export const getFilter = (name, value) =>
	categoryFilters[name].find(({ value: v }) => v === value);
